import axios from 'axios';
import store from './store';
import { getFirebaseCustomerId } from '../apis/firebase';
import { API_CLOUD_WATCH, FRONTEND_DASHBOARD_ALERT, LEVELS } from '../constants';
import isProd from './getEnv';
import _ from 'lodash';
import pckg from '../../package.json';
import winston from 'winston';

const consoleLogger = winston.createLogger({
    transports: [
        new winston.transports.Console({
            format: winston.format.combine(
                winston.format.timestamp(),
                winston.format((info) => {
                    return {
                        timestamp: info.timestamp,
                        level: info.level,
                        message: info.message,
                    };
                })(),
                winston.format.json()
            )
        })
    ]
});

interface FunctionInfo {
    fonctionName?: string;
    descriptionFonction?: string;
    paramsFonction?: Record<string, any>;
}

interface LogEventParams {
    level?: string;
    message: string;
    severity?: string;
    errorCode?: number | null;
    data?: {
        companyId?: string;
        shopId?: string;
        initiatorId?: string;
        initiatorRole?: string;
    };
    contexte?: {
        apiEndpoint?: string;
        location?: string;
        componentStack?: string;
        [key: string]: any;
    };
    fonction?: FunctionInfo;
}

interface LogPayload {
    timestamp: string;
    level: string;
    severity: string | null;
    message: string;
    errorCode: number | null;
    traceId: string;
    data: {
        companyId: string | null;
        shopId: string | null;
        initiatorId: string | null;
        initiatorRole: string | null;
    };
    contexte: {
        version: string;
        stack: string;
        apiEndpoint?: string;
        location?: string;
        componentStack?: string;
        [key: string]: any;
    };
    fonction?: FunctionInfo;
}

export const logEvent = async ({
    level = LEVELS.INFO,
    message,
    severity = '',
    errorCode = null,
    data = {},
    contexte = {},
    fonction
}: LogEventParams): Promise<void> => {
    const { companyId, shopId } = store.getState().user || {};
    const logTypePrefix = level === LEVELS.INFO
        ? '[LOG_INFO_DASHBOARD]'
        : `[${severity.toUpperCase()}_LOG_ERROR_DASHBOARD]`


    const traceId = getFirebaseCustomerId();
    const role = getRoles()
    const logPayload: LogPayload = {
        timestamp: new Date().toISOString(),
        level,
        severity,
        message: `${logTypePrefix} - ${message}`,
        errorCode,
        traceId,
        data: {
            companyId: data.companyId || companyId || null,
            shopId: data.shopId || shopId || null,
            initiatorId: data.initiatorId || traceId || null,
            initiatorRole: data.initiatorRole || role[0] || null,
            ...data
        },
        contexte: {
            ...contexte,
            version: pckg.version,
            stack: contexte.stack || FRONTEND_DASHBOARD_ALERT,

        }
    };

    if (fonction && !_.isEmpty(fonction)) {
        logPayload.fonction = fonction
    }

    try {
        const logOutput = JSON.stringify(logPayload, null, 4);
        consoleLogger.log({
            level: level.toLowerCase(),
            message: logOutput
        });

        if (isProd()) {
            await axios.post(API_CLOUD_WATCH, {
                message: logOutput,
            });
        }

        if (level === LEVELS.ERROR) {
            console.error(logOutput);
        }

    } catch (error) {
        console.error('Error streaming logs to cloudwatch', {
            error: error instanceof Error ? error.message : 'Unknown error',
            originalLog: logPayload
        });
    }
};
const getRoles = () => {
    const {
        generalAdmin,
        independantShopAdmin,
        franchiseShopAdmin,
        chainShopAdmin
    } = store.getState().user || {};

    const roles = {
        generalAdmin,
        independantShopAdmin,
        franchiseShopAdmin,
        chainShopAdmin
    };

    return Object.keys(roles).filter((key) => roles[key]);
};





